import { setSingularElementStyleProperty } from "./setSingularElementStyleProperty.js";
class CSSRenderer {
    constructor(options) {
        this.#renderer = options.document.createElement("div");
    }
    /**
     * A reusable element to render the CSS
     */
    #renderer;
    clear() {
        this.#renderer.style.cssText = "";
    }
    /**
     * Apply the given style object to the renderer
     */
    apply(value) {
        setSingularElementStyleProperty(this.#renderer, undefined, value);
    }
    /**
     * Get the rendered CSS string
     */
    toString() {
        return this.#renderer.style.cssText;
    }
}
const renderers = new WeakMap();
/**
 * @internal scope: workspace
 */
export function renderCSS($document, value) {
    let renderer = renderers.get($document);
    if (!renderer) {
        renderer = new CSSRenderer({ document: $document });
        renderers.set($document, renderer);
    }
    else {
        renderer.clear();
    }
    renderer.apply(value);
    return renderer.toString();
}
